export const AdDistributionEnum = {
  OwnedAndOperatedAndSyndicatedSearch: 'OwnedAndOperatedAndSyndicatedSearch',
  OwnedAndOperatedOnly: 'OwnedAndOperatedOnly',
} as const;

export type AdDistributionType = typeof AdDistributionEnum[keyof typeof AdDistributionEnum];

export const AD_DISTRIBUTION_DEFAULT = AdDistributionEnum.OwnedAndOperatedAndSyndicatedSearch;
